import { render, staticRenderFns } from "./asyncCourse_bar.vue?vue&type=template&id=52746b78&scoped=true&"
import script from "./asyncCourse_bar.vue?vue&type=script&lang=js&"
export * from "./asyncCourse_bar.vue?vue&type=script&lang=js&"
import style0 from "./asyncCourse_bar.vue?vue&type=style&index=0&id=52746b78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52746b78",
  null
  
)

export default component.exports